import { createFileRoute, redirect } from '@tanstack/react-router';
import { Skeleton } from '@/components/ui/skeleton';
import { AppShell } from '@/components/layout/AppShell';
import { KnowledgeCockpit } from '@/components/KnowledgeCockpit';
import { IndexedPagesList } from '@/components/IndexedPagesList';
import { useInventory } from '@/hooks/use-inventory';
import { getToken } from '@/lib/auth';

export const Route = createFileRoute('/websites/$websiteId/knowledge')({
  beforeLoad: () => {
    if (!getToken()) throw redirect({ to: '/connect' });
  },
  component: KnowledgePage,
});

function KnowledgePage() {
  const { websiteId } = Route.useParams();
  const inv = useInventory(websiteId);

  const empty =
    !!inv.data &&
    Object.keys(inv.data.soll).length === 0 &&
    inv.data.assets.length === 0;

  return (
    <AppShell websiteId={websiteId} active="knowledge">
      <div className="mx-auto max-w-4xl p-8">
        <h1 className="mb-6 text-2xl font-semibold">Wissensbasis</h1>

        {inv.isLoading && <Skeleton className="h-40 w-full" />}
        {inv.isError && (
          <p className="text-destructive">Wissensbasis konnte nicht geladen werden.</p>
        )}
        {empty && <p className="text-muted-foreground">Noch nicht gecrawlt.</p>}
        {inv.data && !empty && (
          <div className="space-y-8">
            <KnowledgeCockpit soll={inv.data.soll} ist={inv.data.ist} />
            <IndexedPagesList assets={inv.data.assets} />
          </div>
        )}
      </div>
    </AppShell>
  );
}
